import { t } from "i18next";
import { useEffect, useState } from "react";
import { TbArrowLeft } from "react-icons/tb";
import { NavLink, useParams } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { ProducerById } from "../../../types/types";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import Spinner from "../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/Tabs/Tabs";
import ProducerMainTab from "./producerItemTabs/modelsTab/ProducerMainTab";
import ProducerSettingsTab from "./producerItemTabs/ProducerSettingsTab";

type Props = {
  //equipments: Equipment[] | null;
};

const ProducerItem = (props: Props) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/producers/${id}`);

  useEffect(() => {
    if (!id) {
      return;
    }
    setLoading(true);
    doFetchItem();
  }, [id]);

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    setCurrentProducer(response.data as unknown as ProducerById);
    setLoading(false);
  }, [response]);

  const [currentProducer, setCurrentProducer] = useState<ProducerById>();

  return loading ? (
    <Spinner />
  ) : (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/manufactures"} className="text-sm flex gap-2 items-center text-muted-foreground"><TbArrowLeft />{t("manufactures")}</NavLink>
            <span className="text-2xl font-semibold">{t('editing_producer')}</span>
          </div>
        </div>
        <Tabs defaultValue="settings" >
          <div className="px-6">
            <TabsList className="w-full flex-none h-10 justify-between px-2 rounded">
              <div className="flex">
                <TabsTrigger value="settings">{t("settings")}</TabsTrigger>
                <TabsTrigger value="models">{t("models")}</TabsTrigger>
              </div>
            </TabsList>
          </div>
          <TabsContent value="settings" className="px-6">
            <ProducerSettingsTab id={id} currentProducer={currentProducer} />
          </TabsContent>
          <TabsContent value="models">
            {currentProducer ? <ProducerMainTab id={id} currentProducer={currentProducer} /> : ""}
          </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
};

export default ProducerItem;
